import React, {useCallback, useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {getDocumentById} from '../../rest';
import {validateEgdSchema, validateRefpadoSchema, validateVdkSchema} from '../../json_schemas';
import {
    EGD_DOC_TYPE,
    FLSCOPY_DOC_TYPE,
    FLSEGD_DOC_TYPE,
    FLSOBORVED_DOC_TYPE,
    HOUSEBOOK_DOC_TYPE,
    REFDEBT_DOC_TYPE,
    REFPADO_DOC_TYPE,
    REFPASS_DOC_TYPE,
    REFREGA_DOC_TYPE,
    REFREGD_DOC_TYPE,
    REFREGF_DOC_TYPE,
    ROUTE_INFORMATION,
    VDK_DOC_TYPE
} from '../../constants';
import {BackLink} from '../../components/back_link';
import {ErrorPage} from './ErrorPage';
import './doc_view.scss';
import {DocTypeName, DocumentsBatch, VersionedHbeDocument} from '../../types';
import {triggerYaEvent} from '../../utils/yandex_counter';
import {RefpadoDoc} from './RefpadoDoc';
import {RefregaDoc} from "./RefregaDoc";
import {validateRefregaSchema} from "../../json_schemas/refrega_json_schema";
import {validateRefregfSchema} from "../../json_schemas/refregf_json_schema";
import {validateRefregdSchema} from "../../json_schemas/refregd_json_schema";
import {validateFlscopySchema} from "../../json_schemas/flscopy_json_schema";
import {validateRefpassSchema} from "../../json_schemas/refpass_json_schema";
import {validateRefdebtSchema} from "../../json_schemas/refdebt_json_schema";
import {validateHousebookSchema} from "../../json_schemas/housebook_json_schema";
import {validateFlsegdSchema} from "../../json_schemas/flsegd_json_schema";
import {RefregdDoc} from "./RefregdDoc";
import {RefregfDoc} from "./RefregfDoc";
import {FlscopyDoc} from "./FlscoppyDoc";
import {RefpassDoc} from "./RefpassDoc";
import {RefdebtDoc} from "./RefdebtDoc";
import {HousebookDoc} from "./HousebookDoc";
import {FlsegdDoc} from "./FlsegdDoc";
import {validateFlsobrvedSchema} from "../../json_schemas/flsobrved_json_schema";
import {FlsoborvedDoc} from "./FlsoborvedDoc";
import {VdkDoc} from "./VdkDoc";
import {EgdDoc} from "./EgdDoc";

export const getDocTypeByUid = (uid: string): DocTypeName => {
    const i = uid.indexOf('-');
    if (i < 0) {
        throw new Error(`Unknown document type for uid ${uid}`)
    }
    try {
        return getDocType(uid.substring(0, i));
    } catch (e) {
        throw new Error(`Unknown document type for uid ${uid}`)
    }
}

export const getDocType = (strType: string): DocTypeName => {
    switch (strType) {
        case EGD_DOC_TYPE:
            return EGD_DOC_TYPE;
        case VDK_DOC_TYPE:
            return VDK_DOC_TYPE;
        case REFPADO_DOC_TYPE:
            return REFPADO_DOC_TYPE;
        case REFREGA_DOC_TYPE:
            return REFREGA_DOC_TYPE;
        case REFREGD_DOC_TYPE:
            return REFREGD_DOC_TYPE;
        case REFREGF_DOC_TYPE:
            return REFREGF_DOC_TYPE;
        case REFPASS_DOC_TYPE:
            return REFPASS_DOC_TYPE;
        case FLSCOPY_DOC_TYPE:
            return FLSCOPY_DOC_TYPE;
        case REFDEBT_DOC_TYPE:
            return REFDEBT_DOC_TYPE;
        case HOUSEBOOK_DOC_TYPE:
            return HOUSEBOOK_DOC_TYPE;
        case FLSEGD_DOC_TYPE:
            return FLSEGD_DOC_TYPE;
        case FLSOBORVED_DOC_TYPE:
            return FLSOBORVED_DOC_TYPE;

        default:
            throw new Error(`Unknown document type ${strType}`)
    }
}

const schemaValidate = {
    [VDK_DOC_TYPE]: (jsonData: object | null) => validateVdkSchema(jsonData),
    [EGD_DOC_TYPE]: (jsonData: object | null) => validateEgdSchema(jsonData),
    [REFPADO_DOC_TYPE]: (jsonData: object | null) => validateRefpadoSchema(jsonData),
    [REFREGA_DOC_TYPE]: (jsonData: object | null) => validateRefregaSchema(jsonData),
    [REFREGD_DOC_TYPE]: (jsonData: object | null) => validateRefregdSchema(jsonData),
    [REFREGF_DOC_TYPE]: (jsonData: object | null) => validateRefregfSchema(jsonData),
    [FLSCOPY_DOC_TYPE]: (jsonData: object | null) => validateFlscopySchema(jsonData),
    [REFPASS_DOC_TYPE]: (jsonData: object | null) => validateRefpassSchema(jsonData),
    [REFDEBT_DOC_TYPE]: (jsonData: object | null) => validateRefdebtSchema(jsonData),
    [HOUSEBOOK_DOC_TYPE]: (jsonData: object | null) => validateHousebookSchema(jsonData),
    [FLSEGD_DOC_TYPE]: (jsonData: object | null) => validateFlsegdSchema(jsonData),
    [FLSOBORVED_DOC_TYPE]: (jsonData: object | null) => validateFlsobrvedSchema(jsonData),
};

const filterInvalidDocuments = (batch: DocumentsBatch): DocumentsBatch => {
    const {documentsType, documents, documentId} = batch
    const validDocumentsBatch: DocumentsBatch = {documentsType, documentId, documents: []};

    documents.forEach(data => {
        if (documentsType && schemaValidate[documentsType] && schemaValidate[documentsType](data.document)) {
            validDocumentsBatch.documents.push(data)
        } else {
            console.info(
                    `------->>>>>> Ошибка: Структура полученных с сервера данных не соответствует схеме документа [${documentsType &&
                    docTypeDescription[documentsType]}] `
            );
            // setErrorMessage('');
            // setErrorDescription('');
            // setHasError(true);
        }
    })
    return validDocumentsBatch;
}

export const docRenderer = (docBatch?: DocumentsBatch, withVersions: boolean = true) => {
    if (docBatch) {
        switch (docBatch.documentsType) {
            case VDK_DOC_TYPE:
                return <VdkDoc documents={docBatch} withVersions={withVersions}/>;
            case EGD_DOC_TYPE:
                return <EgdDoc documents={docBatch} withVersions={withVersions}/>;
            case REFPADO_DOC_TYPE:
                return <RefpadoDoc documents={docBatch} withVersions={withVersions}/>;
            case REFREGA_DOC_TYPE:
                return <RefregaDoc documents={docBatch} withVersions={withVersions}/>;
            case REFREGD_DOC_TYPE:
                return <RefregdDoc documents={docBatch} withVersions={withVersions}/>;
            case REFREGF_DOC_TYPE:
                return <RefregfDoc documents={docBatch} withVersions={withVersions}/>;
            case REFPASS_DOC_TYPE:
                return <RefpassDoc documents={docBatch} withVersions={withVersions}/>;
            case FLSCOPY_DOC_TYPE:
                return <FlscopyDoc documents={docBatch} withVersions={withVersions}/>;
            case REFDEBT_DOC_TYPE:
                return <RefdebtDoc documents={docBatch} withVersions={withVersions}/>;
            case HOUSEBOOK_DOC_TYPE:
                return <HousebookDoc documents={docBatch} withVersions={withVersions}/>;
            case FLSEGD_DOC_TYPE:
                return <FlsegdDoc documents={docBatch} withVersions={withVersions}/>;
            case FLSOBORVED_DOC_TYPE:
                return <FlsoborvedDoc documents={docBatch} withVersions={withVersions}/>;
            default:
                return null;
        }
    }
    return null;
};

const getErrorProps = (status: number) => {
    switch (status) {
        case 400:
            return {
                message: 'Неверный формат id',
                description:
                        'Проверьте правильность введенного номера выписки из домовой книги или единого жилищного документа',
            };
        case 404:
            return {
                message: 'Документ не найден',
                description:
                        'Проверьте правильность введенного номера выписки из домовой книги или единого жилищного документа',
            };
        case 406:
            return {
                message: 'Ошибка парсинга документа',
                description:
                        'Проверьте правильность введенного номера выписки из домовой книги или единого жилищного документа',
            };
        case 410:
            return {
                message: 'Документ более не действителен',
                description:
                        'Проверьте правильность введенного номера выписки из домовой книги или единого жилищного документа',
            };
        default:
            return {message: 'Ошибка сервера', description: ' Сервер не может обработать запрос'};
    }
};

const docTypeDescription = {
    [VDK_DOC_TYPE]: 'Выписка из домовой книги',
    [HOUSEBOOK_DOC_TYPE]: 'Выписка из домовой книги',
    [EGD_DOC_TYPE]: 'Единый жилищный документ',
    [FLSEGD_DOC_TYPE]: 'Единый жилищный документ',
    [FLSCOPY_DOC_TYPE]: 'КОПИЯ ФИНАНСОВОГО ЛИЦЕВОГО СЧЕТА',
    [FLSOBORVED_DOC_TYPE]: 'Оборотная ведомость по финансовому лицевому счёту о начислениях и оплатах за жилищно-коммунальные и иные услуги',
    [REFPADO_DOC_TYPE]: 'Справка о наличии/отсутствии задолженности/переплаты',
    [REFREGA_DOC_TYPE]: 'СПРАВКА О РЕГИСТРАЦИИ ПО АДРЕСУ/ОБ ОТСУТСТВИИ ЗАРЕГИСТРИРОВАННЫХ ГРАЖДАН',
    [REFREGD_DOC_TYPE]: 'СПРАВКА ОБ ОДИНОКОМ УМЕРШЕМ/О РЕГИСТРАЦИИ С УМЕРШИМ',
    [REFREGF_DOC_TYPE]: 'СПРАВКА О СОВМЕСТНОЙ РЕГИСТРАЦИИ ПО АДРЕСУ',
    [REFPASS_DOC_TYPE]: 'Выписка из домовой книги',
    [REFDEBT_DOC_TYPE]: 'Справка о наличии/отсутствии задолженности/переплаты',
};

export type selectedDocument = {
    document: VersionedHbeDocument,
    documentTypeName: DocTypeName,
}

const DocsExtract = () => {
    const history = useHistory();
    const {id} = useParams<{ id: string }>();

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorDescription, setErrorDescription] = useState('');
    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>()
    const [docBatch, setDocBatch] = useState<DocumentsBatch>();

    useEffect(() => {
        setIsLoading(true);
        getDocumentById(id)
                .then(docBatch => {
                    setHasError(false);
                    setDocBatch(filterInvalidDocuments(docBatch))
                    setSelectedDocument({
                        document: docBatch.documents[0],
                        documentTypeName: docBatch.documentsType
                    });
                })
                .catch(error => {
                    const {message, description} = getErrorProps(error.response.status);
                    setErrorMessage(message);
                    setErrorDescription(description);
                    setHasError(true);

                    triggerYaEvent('Ошибка посадочной', {'Ошибка перехода на страницу сервиса': error.response.status});
                })
                .finally(() => {
                    setIsLoading(false);
                });
    }, [id]);

    const goToInformation = useCallback(() => {
        triggerYaEvent('Ошибка посадочной', 'Клик по кнопке Назад');
        history.push(ROUTE_INFORMATION);
    }, [history]);

    return (
            <div className="doc-view-container">
                <BackLink handleClick={goToInformation}/>
                {!isLoading &&
                        <div className="doc-view-content">
                            {hasError &&
                                    <ErrorPage
                                            documentId={id}
                                            message={errorMessage}
                                            description={errorDescription}
                                    />}

                            <div className="grid grid-cols-12 gap-2 lg:gap-4">
                                {selectedDocument && docRenderer(docBatch)}
                            </div>
                        </div>
                }
            </div>
    );
};

export {DocsExtract};
